{
  "version": "1.2.6",
  "objects": {
    "7493635533099162594": {
      "type": "frame",
      "id": "7493635533099162594",
      "z": 1726,
      "textContent": "",
      "left": 1168.8404122069178,
      "top": 438.77235351656896,
      "width": 400,
      "height": 500,
      "scaleX": 1.282870236650997,
      "scaleY": 0.9449632208109706,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7493635533097263375": {
      "type": "shape",
      "id": "7493635533097263375",
      "z": 1736,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p>",
      "left": 1188.8404122069178,
      "top": 529.772353516569,
      "width": 230.96371954889239,
      "height": 29.015542656896027,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7493635533099162594",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7493635533105328621": {
      "type": "frame",
      "id": "7493635533105328621",
      "z": 1746,
      "textContent": "Frame 14",
      "left": 1188.8404122069178,
      "top": 458.77235351656896,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.102,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533099162594",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533090011344": {
      "type": "shape",
      "id": "7493635533090011344",
      "z": 1756,
      "shapeName": "icon",
      "textContent": "",
      "left": 1646.8617058530406,
      "top": 473.77091270514813,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7493635533105328621",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7493635533089894553": {
      "type": "shape",
      "id": "7493635533089894553",
      "z": 1796,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#333333\">Title</span></p>",
      "left": 1188.8404122069178,
      "top": 458.77235351656896,
      "width": 36.16666666666667,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7493635533105328621",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7493635533097296519": {
      "type": "frame",
      "id": "7493635533097296519",
      "z": 1766,
      "textContent": "Frame 20",
      "left": 1188.8404122069178,
      "top": 851.3945889220543,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.07971875,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533099162594",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533097652874": {
      "type": "wireframe",
      "id": "7493635533097652874",
      "z": 1786,
      "top": 851.8945889220543,
      "left": 1586.9816709298166,
      "width": 73.0068359375,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533097296519",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#333333",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Confirm" }
    },
    "7493635533100127525": {
      "type": "wireframe",
      "id": "7493635533100127525",
      "z": 1886,
      "top": 851.8945889220543,
      "left": 1188.8404122069178,
      "width": 59.79296875,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533097296519",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#B6B6B6",
      "textColor": null,
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Close" }
    },
    "7493635533098307435": {
      "type": "frame",
      "id": "7493635533098307435",
      "z": 1776,
      "textContent": "Frame 2",
      "left": 1188.8404122069178,
      "top": 574.772353516569,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.5132444708109706,
      "fill": "#333333",
      "opacity": 0.05,
      "container": "7493635533099162594",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    }
  }
}
